import { useDeviceType } from './useDeviceType';

export const useIsMobile = () => {
  const deviceType = useDeviceType();
  return deviceType === 'mobile';
};
